import React from 'react';

import { FieldProps } from 'formik';

import { FormValidationState } from 'utils/form';

import CountrySelectInput from './country-select-input';
import { IBaseProps } from './types';

/** @deprecated Use FormikCountrySelect instead */
const FormikCountrySelectInput: React.FC<IBaseProps & FieldProps> = ({ form, field, ...props }) => (
  <CountrySelectInput
    {...field}
    validation={
      form.touched[field.name] && form.errors[field.name] ? FormValidationState.INVALID : undefined
    }
    message={
      form.touched[field.name] && form.errors[field.name]
        ? (form.errors[field.name] as string)
        : undefined
    }
    {...props}
  />
);

export default FormikCountrySelectInput;
